import React, { useEffect, useState,useRef } from "react";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {Card, CardBody,Modal,ModalHeader,Button,Label,Input} from "reactstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Table from 'react-bootstrap/Table';
import {ToastContainer,toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { v4 as uuidv4 } from 'uuid';
import Axios from 'axios'
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import 'jspdf-autotable';

export default function Notes() {
    const quotationRef = useRef();
    const [agent,setAgent] = useState('')
    const [agentCode, setAgentcode] = useState('')
    const [allNotes, setAllnotes] = useState([])
    const [currentPage, setCurrentPage] = useState(1);    
    const rowsPerPage = 20;
    const totalPages = Math.ceil(allNotes.length / rowsPerPage);
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentPolicies = allNotes.slice(indexOfFirstRow, indexOfLastRow)
    const [search, setSearch] = useState('')
    const [modal, setModal] = useState(false)
    const [proposal,setProposal] = useState('')
    const [noteNumber, setNotenumber] = useState('')
    const [dateDone, setDatedone] = useState('')
    const [client, setClient] = useState('')
    const [pin, setPin] = useState('')
    const [product, setProduct] = useState('')
    const [sumInsured, setSuminsured] = useState('')
    const [reg, setReg] = useState('')
    const [basicPremium, setBasicpremium] = useState('')
    const [tl, setTL] = useState('')
    const [phcf, setPHCF] = useState('')
    const [stamp, setStamp] = useState('')
    const [gross, setGross] = useState('');
    const [commence, setCommence] = useState('')
    const [expiry, setExpiry] = useState('')
      const [credentials, setCredentials] = useState(null)
      const [isAuth, setIsauth] = useState(false)
      const company = 'Definite'
    
      useEffect(()=>{
      const getCredentials =async()=>{
        const res = await fetch(`https://digitalapi.definiteassurance.com/api/getCredentials?username=${company}`)
        const data = await res.json();
        const {Username, Password} = data;
        const cred = btoa(`${Username}:${Password}`)
        setCredentials(btoa(`${Username}:${Password}`))
        setIsauth(true)
    
    
      }
      getCredentials()
    
      },[])
    

    useEffect(() => {

    const user = localStorage.getItem('definiteagent'); // Retrieve email
    if (user) {
        
        setAgent(user)
    } else {
    
    }
    }, []);

    useEffect(()=>{
        const getAgentcode =async()=>{
            const res =await fetch(`https://digitalapi.definiteassurance.com/api/getDealerdetails?email=${agent}`,{
                method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
            });
            const data = await res.json();
            setAgentcode(data.OID)   

        }
        if(agent && isAuth){
            getAgentcode()
        }
    },[agent,isAuth])

    useEffect(()=>{
        const getNotes =async()=>{
            const res = await fetch(`https://digitalapi.definiteassurance.com/api/getNotes?agent=${agentCode}`,{
                method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
            })
            const data = await res.json();
            setAllnotes(data)
        }

        if(agentCode && isAuth){
            getNotes()
        }
    },[agentCode, isAuth])

    function formateDateISO(input){
    if(typeof input === 'string'){
        return input.split('T')[0]
    }
    else if (input instanceof Date){
        return input.toISOString().split('T')[0]
    }
    else{
        return ('')
    }

    throw new Error('Invalid input: Expected ISO String or Date Object')
}

function formatter(amount) {
    return amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    }

useEffect(()=>{
    const searchNote =async()=>{
        const res = await fetch(`https://digitalapi.definiteassurance.com/api/searchNote?agent=${agentCode}&search=${search}`,{
                method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
        })
        const data = await res.json()
        setAllnotes(data)
    }

    if(search && agentCode && isAuth){
        searchNote()
    }
},[search,agentCode,isAuth])


  const downloadPDF = () => {
    const input = quotationRef.current;
    
    html2canvas(input, { scale: 2 })
      .then((canvas) => {
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF('p', 'mm', 'a4');
        const imgWidth = 210; // A4 width in mm
        const pageHeight = 295; // A4 height in mm
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        let heightLeft = imgHeight;
        let position = 0;

        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;

        while (heightLeft >= 0) {
          position = heightLeft - imgHeight;
          pdf.addPage();
          pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;
        }

        pdf.save('quotation.pdf');
      });
  };

  const toggle =async(e)=>{
    const oid = e.target.value
    setProposal(oid)
    const res = await fetch(`https://digitalapi.definiteassurance.com/api/getThisnote?proposal=${oid}`,{
          method:"GET",
          headers:{
            'Authorization': `Basic ${credentials}`,
            'Content-Type': "application/json"
          }
    });
    const data = await res.json();
    setDatedone(formateDateISO(data.DateDone))
    setNotenumber(`NW${data.OID}`)
    setClient(`${data.FirstName} ${data.Surname}`)
    setPin(data.DealerPin)
    setProduct(data.ProductDescription)
    setSuminsured(data.SumInsured)
    setReg(data.Narration)
    setBasicpremium((data.BasicPremium)-(data.TrainingLevy+data.PHCF+data.StampDuty))
    setTL(data.TrainingLevy)
    setPHCF(data.PHCF)
    setStamp(data.StampDuty)
    setGross(data.GrossPremium)
    setCommence(formateDateISO(data.CommencementDate))
    setExpiry(formateDateISO(data.ExpiryDate))



    setModal(!modal)
  }
  return (
    <div>
        <div className="page-content">
        <ToastContainer />
        <Breadcrumbs title="Definite Assurance" breadcrumbItem={`Notes`} />
            <Card className="mini-stats-wid">
                <CardBody>
                    <div className="searchInput">
                         <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="Search by name or registration" onChange={(e)=>{setSearch(e.target.value)}}>
                            <Form.Control  className='inputSearch' value={search}  type="text" placeholder="Search" />
                        </FloatingLabel>
                    </div>
                <div className="table-responsive" style={{padding:'10px'}}>
                <Table striped bordered hover id="policy-table">
                <thead>
                    <tr>
                    <th scope="col">#</th>
                    <th scope="col">Date</th>
                    <th scope="col">Client</th>
                    <th scope="col">Product</th>     
                    <th scope="col">Registration</th>
                    <th scope="col">Gross Premium</th>
                    <th scope="col">Amount Paid</th>
                    <th scope="col">Status</th>
                    


                    </tr>
                </thead>
                <tbody>
                    {currentPolicies.map((val, index) => {
                    // Calculate the correct index based on current page
                    const globalIndex = indexOfFirstRow + index;

                            return (
                                <tr key={val.OID}>
                                <td>{index + 1}</td>
                                <td><button onClick={toggle} value={val.OID} className="tableButton">{formateDateISO(val.DateDone)}</button></td>
                                <td>{val.FirstName} {val.Surname}</td>
                                <td>{val.ProductDescription}</td>
                                <td>{val.Narration}</td>
                                <td>{formatter(val.GrossPremium)}</td>
                                <td>{formatter(val.PaidAmount)}</td>
                                {val.Status == 1 &&
                                    <td>PAID</td>
                                }
                                 {val.Status == 0 &&
                                    <td>NOT PAID</td>
                                }
                                </tr>
                            );

                    })}
                </tbody>
                </Table>

                {/* Pagination controls */}
                <div className="d-flex justify-content-between align-items-center">
                <div>
                    Showing {indexOfFirstRow + 1} to {Math.min(indexOfLastRow, allNotes.length)} of {allNotes.length} entries
                </div>
                <div>
                    <button 
                    className="btn btn-sm btn-outline-primary mx-1"
                    onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                    disabled={currentPage === 1}
                    >
                    Previous
                    </button>
                    
                    {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
                    <button
                        key={page}
                        className={`btn btn-sm mx-1 ${currentPage === page ? 'btn-primary' : 'btn-outline-primary'}`}
                        onClick={() => setCurrentPage(page)}
                    >
                        {page}
                    </button>
                    ))}
                    
                    <button 
                    className="btn btn-sm btn-outline-primary mx-1"
                    onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                    disabled={currentPage === totalPages}
                    >
                    Next
                    </button>
                </div>
                </div>
                </div>
                </CardBody>
            </Card>
    </div>

    <Modal isOpen={modal} toggle={toggle} size="xl">
        <ModalHeader>DOWNLOAD NOTE</ModalHeader>
        <div className="modalContainer">
             <div>
        <p style={{color:'red',float:'right',cursor:'pointer'}} onClick={()=>{setModal(false)}}>CLOSE</p>
      <div ref={quotationRef} className="quotation">
        {/* Header with logo */}
        <div className="header">
          <img src='/definitelogo.png' alt="Company Logo" className="logo" />
          <div className="company-info">
            <h4>Definite Assurance Co. Ltd</h4>
            <p>P.O BOX 30823 - 00100 NAIROBI</p>
            <p>0708247247/0788247247</p>
            <p>info@definiteassurance.com</p>
          </div>
        </div>

        {/* Quotation title */}
        <div className="quotation-title">
          <h4>DEBIT NOTE</h4>
          <p>{dateDone}</p>
          <p>{noteNumber} </p>
        </div>

        {/* Client information */}
        <div className="client-info">
         
          <p>Client: {client} </p>
          <p>Email: </p>
          <p>Pin: {pin} </p>
          <p>Product: {product} </p>
          <p>Sum Insured: {sumInsured} </p>
          <p>Registration: {reg} </p>
        </div>

        {/* Items table */}
        <table className="items-table">
          <thead>
            <tr>
              <th>ITEM DESCRIPTION</th>
              <th>AMOUNT (KES)</th>
            </tr>
          </thead>
          <tbody>
           
              <tr>
                <td>Basic Premium</td>
                <td>{basicPremium}</td>
              </tr>
              <tr>
                <td>Training Levy</td>
                <td>{tl}</td>
              </tr>
              <tr>
                <td>PHCF</td>
                <td>{phcf}</td>
              </tr>
              <tr>
                <td>Stamp duty</td>
                <td>{stamp}</td>
              </tr>
            <tr>
              <td >Total</td>
              <td className="total-amount">{gross}</td>
            </tr>
         
          </tbody>
          
           
     
        </table>
        <div className="datesContainer">
            <div className="">
                <p>Start: {commence}</p>
            </div>
            <div className="">
                Expiry: {expiry}
            </div>
        </div>

        {/* Terms and conditions */}
        <div className="terms">
          <h6>NOTE</h6>
          <p>1. Please note that the Insurance Act Section 156 requires payment of premiums at inception or renewal date of the policy (Cash and Carry)</p>
          <p>2. Insurance claims shall not be paid if any premiums are outstanding. Access to Healthcare credit facilities will be suspended.</p>
          <p>3. This document is only for payment purposes and not proof of cover.
</p>
        </div>

        {/* Footer */}
        {/* <div className="footer">
          <p>Thank you for your business!</p>
        </div> */}
      </div>

      <button onClick={downloadPDF} className="download-btn">
        Download as PDF
      </button>
    </div>
        </div>
    </Modal>
    </div>
  )
}
